<template>
  <div class="tool-footer level is-mobile">
    <span class="tool-footer__span level-item is-narrow">Previewing: </span>
    <ChannelIdentityPicker v-model="channelIdentity" class="tool-footer__channel is-flex-grow-1 level-item" />
    <n-button variant="danger" @click="emit('resetClicked')" class="reset-button level-item is-narrow">
      <RestartIcon class="restart-icon icon-1-3x" />
      Restart
    </n-button>
  </div>
</template>

<script lang="ts" setup>
import ChannelIdentityPicker from '@/features/bots/components/botTestTool/ChannelIdentityPicker.vue';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import RestartIcon from 'vue-material-design-icons/Restart.vue';
import { ref, watch } from 'vue';

const channelIdentity = ref<ChannelIdentityViewModel>({
  id: 'web-assistant-default',
  type: 'web-assistant',
  name: 'Web Assistant',
  externalId: '',
});

const emit = defineEmits<{
  (e: 'channelChanged', type: string, id: string): void;
  (e: 'resetClicked'): void;
}>();

watch(channelIdentity, (identity) => emit('channelChanged', identity.type, identity.id), { immediate: true });
</script>

<style lang="scss" scoped>
.tool-footer {
  padding: 0.75rem 1rem 0.75rem 0.75rem;
  background: $color-netcall-light-grey;
  width: 100%;
  &__channel {
    justify-content: flex-start;
  }
  &__span {
    margin-right: 0.5rem;
  }
  .restart-icon {
    margin-right: 0.5rem;
  }
}
</style>
